import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AdditionalInfoSection from './sections/AdditionalInfoSection';

type Props = {}

const AdditionalInfo = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");

  return (
    <>
      <Header title={t("additionalInfo.title")} includeBreadcrumbs />
      <ModuleContent>
        <AdditionalInfoSection />
      </ModuleContent>
    </>
  )
}

export default AdditionalInfo;